
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthContext, useAuthState } from './hooks/useAuth';

function App() {
  const authState = useAuthState();

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthContext.Provider value={authState}>
          <AppRoutes />
        </AuthContext.Provider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
